import { Button, Select } from "@netfront/ui-library";
import { getFriendlyStatus } from "./UserProgressTable.helpers";
import { ExportActionsProps } from "./ExportActions.interfaces";
import { KanziPrintButton } from "@/components/KanziPrintButton";

const exportToCSV = ({ users, userTrackings }: ExportActionsProps) => {
  const maxModules = Math.max(...userTrackings.map(u => u.progress.length), 0);
  const moduleHeaders = Array.from({ length: maxModules }, (_, i) => `Module ${i + 1}`);
  const headers = ['Name', 'Email', 'Class', ...moduleHeaders];

  const rows = userTrackings.map(({ progress, userId }) => {
    const membership = users.find(({ node: { user } }) => user?.id === userId)?.node;
    const name = `${membership?.user?.firstName ?? ''} ${membership?.user?.lastName ?? ''}`.trim();
    const email = membership?.user?.credential?.email ?? '';
    const unit = membership?.unit?.name ?? '';
    const moduleStatuses = progress.map(({ status }) => getFriendlyStatus(status));
    return [name, email, unit, ...moduleStatuses];
  });

  const csvContent = [headers, ...rows]
    .map(row => row.map(cell => {
      const escaped = String(cell).replace(/"/g, '""');
      return /^[=+\-@]/.test(escaped) ? `"\t${escaped}"` : `"${escaped}"`;
    }).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'student-progress.csv';
  link.click();
  URL.revokeObjectURL(url);
};


export const ExportActions = ({ filterUnitId, units, users, userTrackings, onFilterChange }: ExportActionsProps) => {
  return (
    <>
      <div className="c-export-actions">
        <Select
          hasPadding={false}
          id="class-filter"
          labelText="Filter by class"
          isLabelHidden
          labelDefaultText="All classes"
          name="class-filter"
          options={units.map(({ id, name }) => ({ id, name, value: String(id) }))}
          value={filterUnitId}
          onChange={({ currentTarget: { value } }) => onFilterChange(value)}
        />
        <Button
          text="Download Spreadsheet"
          variant="primary-inverse"
          size="small"
          onClick={() => exportToCSV({ filterUnitId, units, users, userTrackings, onFilterChange })}
        />
        <KanziPrintButton variant="primary-inverse" size="small" text="Download PDF" />
      </div>
      <div className="c-module-key">
        <span className="c-module-key__item">
          <span className="c-bordered-circle c-bordered-circle--default c-module-key__swatch" aria-hidden="true" />
          Not started
        </span>
        <span className="c-module-key__item">
          <span className="c-bordered-circle c-bordered-circle--orange c-module-key__swatch" aria-hidden="true" />
          In progress
        </span>
        <span className="c-module-key__item">
          <span className="c-bordered-circle c-bordered-circle--green c-module-key__swatch" aria-hidden="true" />
          Completed
        </span>
      </div>
    </>
  );
};
